export default () => {
	const learnMoreWrapper = $(".learn-more"),
  			learnMoreLink = $(".js-link-learn-more");

  if ( learnMoreLink ) {
      learnMoreLink.on("click", function () {
          learnMoreWrapper.addClass("learn-more-version-tablet");
      });    
  }   
};
